<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">卖闲置卡</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 商家选择  开始 -->
    <div class="page_top"></div>
    <div class="page_taocan sellingcard_top">
      <div class="page_taocan_list sellingcard_topList">
        <div class="selling-cardcheckbox" @click="cardTapeShow">
          <div class="selling-cardtitle">卡类</div>
          <div :class="cardTypeName ? 'selling-cardvalue' : 'selling-cardvalue1'">{{cardTypeName ? cardTypeName : '请选择卡类'}}</div>
          <img class="selling-cardicon" src="../../../static/newicon/more.png" />
        </div>
        <div class="selling-cardcheckbox" @click="priceTypeShow">
          <div class="selling-cardtitle">面值</div>
          <div :class="priceTypeText ? 'selling-cardvalue' : 'selling-cardvalue1'">{{priceTypeText ? priceTypeText : '请选择面值'}}</div>
          <img class="selling-cardicon" src="../../../static/newicon/more.png" />
        </div>
        <div class="selling-cardtabbox">
          <div :class="item.check ? 'selling-cardtabs':'selling-cardtabs1'" v-for="(item,index) in tabs" @click="changetabs(index)">
            <div class="selling-cardtabtext">{{item.name}}</div>
          </div>
        </div>
        <div class="selling-cardtextare" v-if="tabsId==1">
          <textarea class="selling-textarea" v-model="cardMesg" placeholder="每张卡密为一行，卡号与密码之间请使用“空格”隔开"></textarea>
        </div>
        <div class="selling-inputcardboxbox" v-else>
          <div class="selling-inputcardbox">
            <div class="selling-card1title">卡号<span style="color: #029DFF;">(请确保准确无误)</span></div>
            <input class="selling-cardinput" v-model="cardNo" placeholder="请输入卡号" />
          </div>
          <div class="selling-inputcardbox">
            <div class="selling-card1title">卡密<span style="color: #029DFF;">(请确保准确无误)</span></div>
            <input class="selling-cardinput" v-model="cardPassword" placeholder="请输入卡密" />
          </div>
        </div>
        <!-- 注意事项  开始 -->
        <div class="page_mesg">
          <div class="page_mesgtitle">
            <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
            <div class="page_mesgtext">注意事项</div>
          </div>
          <div class="page_mesgtip" style="color: #029DFF;">{{rules}}</div>
        </div>
        <!-- 注意事项  结束 -->
        <!-- 回收协议 开始 -->
        <div class="selling-returnbox">
          <img class="selling-returnicon" src="../../../static/checkdeicon.png" />
          <div class="selling-returntext">我已阅读，理解并接受<span style="color: #029DFF;">回收说明和协议</span></div>
        </div>
        <!-- 回收协议 结束 -->
      </div>
    </div>
    <!-- 商家选择  结束 -->
    <div class="selling-bottom">
      <img class="selling-call" src="../../../static/callkefu.png" />
      <div class="selling-confirom" @click="confrimMesg">确认提交</div>
    </div>
    <!-- 弹框 开始 -->
    <el-dialog :visible.sync="cardType" width="90%" :before-close="carTypeCancel">
      <div class="cardtype-title">请选择卡类</div>
      <div class="cardtype-cardlist">
        <div :class="item.check ? 'cardtype-box1':'cardtype-box'" v-for="(item,index) in cardTypeList" @click="changeardTypeList(index)">
          <img v-if="item.check" class="cardtype-icon" src="../../../static/newprojecticon/chongzhicheck.png" />
          <img class="cardtype-img" src="../../../static/dianxin.png" :src="item.img" />
        </div>
      </div>
      <div class="cardtype-bottom">
        <div class="cardtype-cancel" @click="carTypeCancel">取消</div>
        <div class="cardtype-confirm" @click="cardTapeClose">确定</div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="priceType" width="90%" :before-close="priceTypeCancel">
      <div class="cardtype-title">请选择面值</div>
      <div class="cardtype-cardlist">
        <div :class="item.check ? 'cardtype-box1':'cardtype-box'" v-for="(item,index) in priceTypeList" @click="changePriceTypeList(index)">
          <img v-if="item.check" class="cardtype-icon" src="../../../static/newprojecticon/chongzhicheck.png" />
          <div :class="item.check ? 'pricetype-text1' : 'pricetype-text'">{{item.text}}</div>
        </div>
      </div>
      <div class="cardtype-bottom">
        <div class="cardtype-cancel" @click="priceTypeCancel">取消</div>
        <div class="cardtype-confirm" @click="priceTypeClose">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        tabs: [{
          name: "批量提交",
          check: true,
          id: 1
        }, {
          name: "单卡提交",
          check: false,
          id: 2
        }], //tabs
        tabsindex: 0, //tabs列索引
        tabsId: 1, //tab是id
        cardType: false, //卡类弹框
        cardTypeList: [{
          img: "../../../static/dianxin.png",
          text: "中国电信",
          check: true,
          id: 1,
          rule: "提交面值不符全单损失！【卡密规则】卡号为19位，密码18位。面值选择错误损失概不负责，卡号密码不相符损失自负，不能有误！批量提交无效卡永久封号不予解封！",
          priceTypelist: [{
            price: "30",
            text: "30元",
            check: true,
            priceid: 1
          }, {
            price: "50",
            text: "50元",
            check: false,
            priceid: 2
          }, {
            price: "100",
            text: "100元",
            check: false,
            priceid: 3
          }, {
            price: "200",
            text: "200元",
            check: false,
            priceid: 4
          }]
        }, {
          img: "../../../static/yidong.png",
          text: "中国移动",
          check: false,
          id: 2,
          rule: "面值不符将全单损失！卡号与密码不匹配将全单损失！【卡密规则】卡号为17位，卡密为18位。批量提交无效卡永久封号不予解封！",
          priceTypelist: [{
            price: "30",
            text: "30元",
            check: true,
            priceid: 1
          }, {
            price: "50",
            text: "50元",
            check: false,
            priceid: 2
          }, {
            price: "100",
            text: "100元",
            check: false,
            priceid: 3
          }, {
            price: "200",
            text: "200元",
            check: false,
            priceid: 4
          }]
        }, {
          img: "../../../static/liantong.png",
          text: "中国联通",
          check: false,
          id: 3,
          rule: "提交面值不符全单损失！【卡密规则】卡号15位，密码19位，面值选择错误损失概不负责，卡号密码不相符损失自负，不能有误！",
          priceTypelist: [{
            price: "30",
            text: "30元",
            check: true,
            priceid: 1
          }, {
            price: "50",
            text: "50元",
            check: false,
            priceid: 2
          }, {
            price: "100",
            text: "100元",
            check: false,
            priceid: 3
          }, {
            price: "200",
            text: "200元",
            check: false,
            priceid: 4
          }]
        }, {
          img: "../../../static/zhongshihua.png",
          text: "中石化加油卡",
          check: false,
          id: 4,
          rule: "卡号为16位、卡密为20位。面值不符造成损失概不负责！请提交前仔细核对！（中石化官方每天22：30-凌晨1：00维护）",
          priceTypelist: [{
            price: "100",
            text: "100元",
            check: true,
            priceid: 1
          }, {
            price: "200",
            text: "200元",
            check: false,
            priceid: 2
          }, {
            price: "500",
            text: "500元",
            check: false,
            priceid: 3
          }, {
            price: "1000",
            text: "1000元",
            check: false,
            priceid: 4
          }]
        }, {
          img: "../../../static/zhongshiyou.png",
          text: "中石油加油卡",
          check: false,
          id: 5,
          rule: "17位卡号、卡密19位，面值一定要选择正确，如造成损失后果自负！",
          priceTypelist: [{
            price: "100",
            text: "100元",
            check: true,
            priceid: 1
          }, {
            price: "200",
            text: "200元",
            check: false,
            priceid: 2
          }, {
            price: "500",
            text: "500元",
            check: false,
            priceid: 3
          }, {
            price: "1000",
            text: "1000元",
            check: false,
            priceid: 4
          }]
        }], //卡类列表
        cardTypename: "中国电信", //卡类名字1
        cardTypeName: "", //卡类名字
        cardTypeId: 1, //卡类id
        priceType: false, //面值弹框
        priceTypeList: [], //面值列表
        priceTypevalue: "", //面值价格1
        priceTypeValue: "", //面值价格
        priceTypetext: "", //显示面值1
        priceTypeText: "", //显示面值
        priceTypeId: 1, //面值id
        cardMesg: "", //批量提交内容
        cardNo: "", //卡号
        cardPassword: "", //卡密
        rules: "请核对好卡号卡密以及充值面值，面值选择错误损失概不负责，卡号密码不相符损失自负，不能有误！", //充值规则
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      //多卡 单卡改变tabs
      changetabs(e) {
        let that = this
        let tabs = that.tabs
        tabs.map((item, index) => item.check = index === Number(e))
        that.tabsId = tabs[Number(e)].id
        this.tabs = tabs
        if (that.tabsId == 1) {
          that.cardNo = ""
          that.cardPassword = ""
        } else {
          that.cardMesg = ""
        }
      },
      //卡类确认按钮
      cardTapeClose() {
        this.cardTypeName = this.cardTypename
        this.cardType = false
        this.priceTypeValue = ""
        this.priceTypeText = ""
      },
      //卡类弹框
      cardTapeShow() {
        this.cardType = true
        this.priceTypeList = this.cardTypeList[0].priceTypelist
        this.rules = this.cardTypeList[0].rule
        this.cardTypeList.map((item, index) => item.check = index == 0)
      },
      //改变卡类
      changeardTypeList(e) {
        let that = this
        let cardtypelist = that.cardTypeList
        cardtypelist.map((item, index) => item.check = index === Number(e))
        that.cardTypename = cardtypelist[Number(e)].text
        that.cardTypeId = cardtypelist[Number(e)].id
        that.priceTypeList = cardtypelist[Number(e)].priceTypelist
        that.rules = cardtypelist[Number(e)].rule
        that.cardTypeList = cardtypelist
      },
      //卡类取消按钮
      carTypeCancel() {
        this.cardTypeName = ""
        this.cardType = false
        this.priceTypeValue = ""
        this.priceTypeText = ""
      },
      //面值 确定按钮
      priceTypeClose() {
        this.priceTypeValue = this.priceTypevalue
        this.priceTypeText = this.priceTypetext
        this.priceType = false
        this.priceTypeList = []
      },
      //面值弹框
      priceTypeShow() {
        if (this.priceTypeList.length == 0) {
          this.$toast({
            message: '请先选择卡类'
          })
          return
        }
        this.priceType = true

        this.priceTypevalue = this.priceTypeList[0].price
        this.priceTypetext = this.priceTypeList[0].text
        // this.priceTypeList[0].check = true
        this.priceTypeList.map((item, index) => item.check = index == 0)
      },
      //面值取消按钮
      priceTypeCancel() {
        this.priceTypeValue = ""
        this.priceTypeText = ""
        this.priceType = false
        this.priceTypeList = []
      },
      //改变面值
      changePriceTypeList(e) {
        let that = this
        let priceTypelist = that.priceTypeList
        priceTypelist.map((item, index) => item.check = index === Number(e))
        that.priceTypevalue = priceTypelist[Number(e)].price
        that.priceTypetext = priceTypelist[Number(e)].text
        that.priceTypeId = priceTypelist[Number(e)].priceid
        that.priceTypeList = priceTypelist
      },
      //确认提交
      confrimMesg() {
        let that = this
        let requestData = {}
        if (!that.cardTypeName) {
          this.$toast({
            message: '请选择卡类',
          })
          return
        }
        if (!that.priceTypeValue) {
          this.$toast({
            message: '请选择面值',
          })
          return
        }

        if (that.tabsId == 1) {
          if (!that.cardMesg) {
            this.$toast({
              message: '请输入卡号卡密',
            })
            return
          }
        } else {
          if (!that.cardNo) {
            this.$toast({
              message: '请输入卡号',
            })
            return
          }
          if (!that.cardPassword) {
            this.$toast({
              message: '请输入卡密',
            })
            return
          }
        }
        this.$toast({
          message: '提交成功',
        })
      },
      // 调用接口封装
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //确认提交
          case '':
            httper.post('', requestData, res => {
              if (res.code === 0) {
                this.$toast({
                  message: '提交成功',
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>

<style>
  .sellingcard_top {
    /* height: 290px;
    top: 21px; */
    /*    height: 222px; */
    top: -185px;
    padding: 0;
    height: auto;
  }

  .sellingcard_topList {
    /* justify-content: center; */
    width: 100%;
    height: 100%;

  }

  .selling-cardcheckbox {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #D2D2D2;
    display: flex;
    align-items: center;
  }

  .selling-cardtitle {
    font-size: 15px;
    color: #000000;
    font-weight: bold;
    margin-right: 10px;
  }

  .selling-cardvalue {
    width: calc(100% - 60px);
    font-size: 15px;
    color: #FD8C00;
    margin-right: 4px;
  }

  .selling-cardvalue1 {
    width: calc(100% - 60px);
    font-size: 15px;
    color: #BBBBBB;
    margin-right: 4px;
  }

  .selling-cardicon {
    width: 14px;
    height: 14px;
  }

  .selling-cardtabbox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-top: 30px;
    border-bottom: 1px solid #E5E5E5;
  }

  .selling-cardtabs {
    width: 70px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 4px solid #FD8C00;
    font-size: 15px;
    color: #FD8C00;
    font-weight: bold;
  }

  .selling-cardtabs1 {
    width: 70px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 4px solid #FFFFFF;
    font-size: 15px;
    color: #666666;
  }

  .selling-cardtabtext {}

  .selling-cardtextare {
    width: 100%;
    min-height: 260px;
    padding: 20px;
    box-sizing: border-box;
  }

  .selling-textarea {
    font-size: 15px;
    width: 100%;
    height: 100%;
  }

  .selling-inputcardboxbox {
    width: 100%;
    padding: 20px 0;
    box-sizing: border-box;
  }

  .selling-inputcardbox {
    width: 100%;
    margin-top: 10px;
    padding: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #E5E5E5;
  }

  .selling-card1title {
    font-size: 12px;
    color: #666666;
    margin-bottom: 10px;
  }

  .selling-cardinput {
    font-size: 15px;
    color: #000000;
    width: 100%;
  }

  .selling-returnbox {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .selling-returnicon {
    width: 19px;
    height: 19px;
    margin-right: 5px;
  }

  .selling-returntext {
    font-size: 14px;
    color: #363636;
  }

  .selling-bottom {
    position: fixed;
    bottom: 10px;
    left: 0;
    display: flex;
    width: 100%;
    background-color: #FFFFFF;
    align-items: center;
    padding: 10px 20px;
    box-sizing: border-box;
    box-shadow: 0px 5px 7px 10px rgba(187, 187, 187, 0.3)
  }

  .selling-call {
    width: 50px;
    height: 50px;
    margin-right: 20px;
  }

  .selling-confirom {
    width: 268px;
    height: 38px;
    background: #FD8C00;
    border-radius: 19px;
    font-size: 15px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input {
    border: none;
    outline: none;
  }

  textarea {
    border: none;
    outline: none;
  }

  .cardtype-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 15px;
    color: #000000;
    font-weight: bold;
  }

  .cardtype-cardlist {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }

  .cardtype-box {
    width: 90px;
    height: 90px;
    background: #FFFFFF;
    border: 1px solid #BFBFBF;
    border-radius: 4px;
    /*    padding: 14px;
    box-sizing: border-box; */
    margin-bottom: 16px;
  }

  .cardtype-box1 {
    width: 90px;
    height: 90px;
    background: #FFFFFF;
    border: 1px solid #FD8C00;
    border-radius: 4px;
    /*    padding: 14px;
    box-sizing: border-box; */
    margin-bottom: 16px;
    position: relative;
  }

  .cardtype-icon {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20px;
    height: 20px;
  }

  .cardtype-img {
    width: 100%;
    height: 100%;
  }

  .pricetype-text {
    width: 100%;
    height: 100%;
    font-size: 16px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pricetype-text1 {
    width: 100%;
    height: 100%;
    font-size: 16px;
    color: #FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cardtype-bottom {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .cardtype-cancel {
    width: 115px;
    height: 46px;
    border: 1px solid #7D7D7D;
    border-radius: 23px;
    font-size: 15px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cardtype-confirm {
    width: 115px;
    height: 46px;
    background: #FD8C00;
    border-radius: 23px;
    font-size: 15px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/sellingCards.vue